import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Maintenance = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Maintenance Provider</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=" "
                />
                <meta
                    name="keywords"
                    content=" "
                />
            </Helmet>
            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Maintenance and Evolution Services</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/maintenance.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">
                                Codezix provides comprehensive administration and development support for Salesforce solutions, ensuring their stable performance and rapid enhancements when needed. Our services include 24/7 system monitoring, user help desk, functionality upgrades, and more.
                            </p>
                        </div>

                        <div className="why-winklix">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix</h2>
                            </div>
                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg">Codezix is proud to be recognized as a 3-Year Champion in The Americas’ Fastest-Growing Companies Rating by the Financial Times.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in IT business.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in CRM services.</li>
                                    <li className="wow fadeUp prose-lg">200+ professionals on board.</li>
                                    <li className="wow fadeUp prose-lg">Expertise across industries such as manufacturing, retail, professional services, healthcare, banking, telecommunications, and more.</li>
                                </ul>
                            </div>

                            <div className='client-section'>
                                <div className='row mt-5'>
                                    <Swiper
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            640: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            768: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 5,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className="testimonialSwiper-client"
                                    >
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-5.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-1.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-4.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>

                        <div className="contact-shadow mt-5">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Ensure the Health of Your Salesforce Solution with Codezix.</h3>
                                        <p className="prose-lg wow fadeUp">Get a comprehensive review of your Salesforce CRM with a Salesforce audit from Codezix. We’ll evaluate your Salesforce processes, records, and user roles to ensure they are functioning optimally and address any deficiencies, helping you maximize the potential of your CRM.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button>Request Salesforce audit</button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services mt-5">
                            <div className='explore-heading text-left'>
                                <h2>The Scope of Our Salesforce Support Offering</h2>
                                <p className="wow fadeUp prose-lg text-left">We manage the full development and administration support of your Salesforce solution or handle specific support functions, based on your needs.</p>
                            </div>
                            <h3>Administration support</h3>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/maintenance/1.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Daily administration.</strong> We configure Salesforce solutions based on user requests, such as setting up workflows, customizing reports, and installing apps, to ensure seamless Salesforce-supported business operations.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/maintenance/2.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Data administration. </strong> We upload and cleanse data in your Salesforce solution, set up duplicate and validation rules, and perform other tasks to ensure data accuracy and integrity.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/maintenance/3.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>24/7 System monitoring. </strong> We promptly identify and resolve errors in Salesforce performance, helping to prevent critical issues and ensuring smooth operation.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/maintenance/4.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Monthly health checks. </strong> We assess your Salesforce solution for inefficiencies, identifying features and processes that need optimization.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/maintenance/5.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>User help desk. </strong> We provide user support for your Salesforce solution, addressing everything from system unavailability to issues impacting multiple users.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="selesforce-services mt-5 mb-4">
                            <div className='explore-heading text-left'>
                                <h2>Development support</h2>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/maintenance/6.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Troubleshooting. </strong> We quickly respond to complex performance, security, and other Salesforce issues that require fixes at the code level.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/maintenance/7.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>System evolution. </strong> We implement enhancements, including significant ones, to your Salesforce solution based on change requests, modifying default functionality swiftly and without disrupting current business operations.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Products We Support </h2>
                                <p className="wow fadeUp prose-lg text-left">We support the following Salesforce products:</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/customization#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services mt-5">
                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Cooperation Stages</h2>
                                    <p className="wow fadeUp prose-lg text-left">Though Salesforce is a powerful platform for sales and marketing automation, some companies need to extend its capabilities. In this regard, the Codezix team can deliver Salesforce integration to:</p>
                                </div>
                                <h3 className="para_heading"><span className="num_cont">01</span> Transition</h3>
                                <div className="why-listing mt-4 ml-3">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"> We evaluate the state of your Salesforce solution by gathering input from both IT and business departments, reviewing incident history, change backlogs, and aligning with your business needs.</li>
                                        <li className="wow fadeUp prose-lg"> We facilitate knowledge transfer and mining, including documentation on configurations, customizations, and more.</li>
                                        <li className="wow fadeUp prose-lg"> We manage service planning and oversee the transfer of responsibilities.</li>
                                    </ul>
                                </div>
                                <h3 className="para_heading"><span className="num_cont">02</span> Service delivery</h3>
                                <p className="wow fadeUp prose-lg ml-5">We deliver the agreed-upon scope of Salesforce support and provide monthly performance analysis and reporting. Throughout our partnership, we adhere to consistent security standards to ensure the safety of your business information. Our robust approach to information security management is validated by ISO 27001 certification.</p>
                                <h3 className="para_heading"><span className="num_cont">03</span> Improvements</h3>
                                <p className="wow fadeUp prose-lg ml-5">We provide quarterly recommendations for potential process improvements.</p>
                            </div>

                            <div className="caroporate-model">
                                <div className='explore-heading text-left'>
                                    <h2>Cooperation Models</h2>
                                    <p className="wow fadeUp prose-lg text-left">We manage support tickets according to ITSM best practices. If modifications are needed for your Salesforce solution, we offer two cooperation options:</p>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="modeling">
                                            <img src={require('../../assets/images/maintenance/model-1.webp')} alt="" />
                                            <h3>The task-based model</h3>
                                            <p className="wow fadeUp prose-lg">Our team processes change tickets that include technical requirements for custom functionality. These change tickets are initiated by business departments and approved by IT managers on the customer’s side.</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="modeling">
                                            <img src={require('../../assets/images/maintenance/model-2.webp')} alt="" />
                                            <h3>The need-based model</h3>
                                            <p className="wow fadeUp prose-lg">Our team processes change requests outlining the customer’s business needs. We work closely with the customer’s business departments to define detailed requirements and implement changes based on them.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="salesforce-product top">
                                <div className='explore-heading text-left'>
                                    <h2>Pricing Model</h2>
                                    <p className="wow fadeUp prose-lg text-left">The total price of the Salesforce technical support service consists of:</p>
                                    <div className="row">
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Monthly fees are based on the number of Salesforce users in your company, the selected service scope, and the complexity of customizations in your Salesforce solution.</li>
                                                <li className="wow fadeUp prose-lg">Payments are made on a Time & Materials (T&M) model for services beyond the scope covered by the fixed monthly price.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="salesforce-product top">
                                <div className='explore-heading text-left'>
                                    <h2>KPIs</h2>
                                    <p className="wow fadeUp prose-lg text-left">We are self-managed while maintaining transparency in our work. You can track the effectiveness of our support services through key performance indicators (KPIs) such as:</p>
                                    <div className="row">
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Number of Cases Resolved (categorized by type: incidents, change requests).</li>
                                                <li className="wow fadeUp prose-lg">Average Case Resolution Time.</li>
                                                <li className="wow fadeUp prose-lg">User Satisfaction.</li>
                                                <li className="wow fadeUp prose-lg">SLA Success Rate.</li>
                                                <li className="wow fadeUp prose-lg">Complaint Escalation Rate.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="contact-shadow top_padding">
                                <div className="row mb-4">
                                    <div className="valuation-box">
                                        <div className="col-md-9">
                                            <h3>Let’s Solve Your Salesforce Challenges!</h3>
                                            <p className="prose-lg wow fadeUp">The Codezix team of Salesforce experts is ready to handle your Salesforce technical support needs.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="button_exp mt-5">
                                                <Link to="/contact"><button>Contact us</button> </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Maintenance;